import {
  ALLOCATION_COLORS,
  BENCHMARK_COLOR,
  PORTFOLIO_COLOR,
  useReferenceData,
} from "@iliotech/data-wire";
import { SimpleTable } from "src/main";

const DiamondIcon = ({ color }: { color: string }) => (
  <svg width="20" height="20" viewBox="0 0 24 24">
    <path d="M12 2L22 12L12 22L2 12L12 2Z" fill={color} />
  </svg>
);

const CircleIcon = ({ color }: { color: string }) => (
  <svg width="32" height="32" viewBox="0 0 32 32">
    <circle cx="16" cy="16" r="8" fill={color} />
  </svg>
);

const RiskVsReturnTable = ({ data }: { data: any }) => {
  const { getAssetLabel } = useReferenceData();
  const renderReturnOrVolatility = (props: any) => {
    const value = props.dataItem[props.field];
    return (
      <td>
        {value === 0
          ? "0%"
          : value
          ? value?.toLocaleString(undefined, {
              maximumFractionDigits: 2,
            }) + "%"
          : ""}
      </td>
    );
  };

  const renderMarketValue = (props: any) => {
    const value = props.dataItem[props.field];
    return (
      <td>
        {value?.toLocaleString(undefined, {
          maximumFractionDigits: 2,
        })}
      </td>
    );
  };

  const renderName = (props: any) => {
    const value = props.dataItem[props.field];
    const renderIndicator = (value: string) => {
      const isBenchmark = value === "Benchmark";
      const isPortfolio = value === "Portfolio";
      const color = isBenchmark
        ? BENCHMARK_COLOR
        : isPortfolio
        ? PORTFOLIO_COLOR
        : ALLOCATION_COLORS[value];

      return (
        <span
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: 32,
            height: 32,
          }}
        >
          {isBenchmark ? (
            <DiamondIcon color={color} />
          ) : (
            <CircleIcon color={color} />
          )}
        </span>
      );
    };
    return (
      <td
        style={{
          display: "flex",
          flexDirection: "row",
          alignContent: "center",
          alignItems: "center",
          fontWeight: "bold",
        }}
      >
        {renderIndicator(value)}
        {getAssetLabel(value)}
      </td>
    );
  };
  const columns = [
    {
      field: "name",
      title: " ",
      cell: renderName,
    },
    {
      field: "return",
      title: "Return",
      cell: renderReturnOrVolatility,
    },
    {
      field: "volatility",
      title: "Volatility",
      cell: renderReturnOrVolatility,
    },
    {
      field: "marketVal",
      title: "Market val (base)",
      cell: renderMarketValue,
    },
  ];

  return <SimpleTable data={data} columns={columns} />;
};

export default RiskVsReturnTable;
